import React from 'react';
import styles from '../styles/common.less';

const EmptyData = ({ text = '暂无数据', className }) => {
  return (
    <div className={`${styles['no-data']} ${className}`}>
      <img src={require('@/assets/images/invite/no-data.png')} alt="no-data" />
      <div className={styles['no-text']}>{text}</div>
    </div>
  );
};

export default EmptyData;
